import { AxiosResponse } from 'axios';

import api from '~/services/api';
import { DailyRouteReportData } from './daily-route-report-interface';
import { UserInterface } from '@e3labs/isa-data-dictionary';

class DailyRouteReportServices {
  getListSuccessDailyRouteReports(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<DailyRouteReportData[] | null>> {
    return api.get('/vendor-client-visit/daily-route/report-json', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getSuccessRowCount({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/daily-route/report-json?isCount=true', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getListFailedDailyRouteReports(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<DailyRouteReportData[] | null>> {
    return api.get('/vendor-client-visit/daily-route/report-json', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getFailedRowCount({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/daily-route/report-json?isCount=true', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getCSVSuccessDailyRouteReports({ ...params }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/daily-route/report-csv', {
      params: {
        ...params
      },
      headers: {
        'Content-Disposition': 'attachment; filename=report.csv',
        'Content-Type': 'text/csv'
      },
      responseType: 'arraybuffer'
    });
  }

  getXslxSuccessDailyRouteReports({ ...params }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/daily-route/report-xlsx', {
      params: {
        ...params
      },
      headers: {
        'Content-Disposition': 'attachment; filename=report.xlsx',
        'Content-Type': 'application/vnd.ms-excel'
      },
      responseType: 'arraybuffer'
    });
  }

  getSellers(opts?: any): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user/subordinates', {
      params: {},
      ...opts
    });
  }
}

export default new DailyRouteReportServices();
